var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.2917 5.83325V13.3333C17.2917 14.2333 16.775 15.0083 16.025 15.3833C16.0333 15.2583 16.0417 15.1333 16.0417 14.9999V7.49992C16.0417 5.54992 14.45 3.95825 12.5 3.95825H5.525C5.90834 3.21659 6.675 2.70825 7.56667 2.70825H14.1667C15.8917 2.70825 17.2917 4.10825 17.2917 5.83325ZM12.5 5.20825H5C3.73584 5.20825 2.70834 6.23575 2.70834 7.49992V14.9999C2.70834 16.2641 3.73584 17.2916 5 17.2916H12.5C13.7642 17.2916 14.7917 16.2641 14.7917 14.9999V7.49992C14.7917 6.23575 13.7642 5.20825 12.5 5.20825Z",
    fill: "#FFB829"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.3f6b43e0a8365e0a1f6446e3505511f1.svg";
export { ForwardRef as ReactComponent };